import { Box, FormControl, FormLabel, Text } from '@chakra-ui/react'
import BasicDateStringPicker from '../../../../../components/BasicDateStringPicker'
import { Profile } from '../../../../../types/FirestoreUser'

interface MedicalDatesSectionProps {
  profile: Profile
  extraInfoRequired: boolean
  areDateFieldsDisabled: boolean
  areFirstSymptomsFieldsDisabled: boolean
  isDiagnosisDateLocked?: boolean
  isFirstSymptomsDateLocked?: boolean
  onUpdate: (changes: Partial<Profile>) => void
}

const MedicalDatesSection = ({
  profile,
  extraInfoRequired,
  areDateFieldsDisabled,
  areFirstSymptomsFieldsDisabled,
  isDiagnosisDateLocked,
  isFirstSymptomsDateLocked,
  onUpdate,
}: MedicalDatesSectionProps) => {
  return (
    <>
      <FormControl>
        <FormLabel>
          Date of First Symptoms{' '}
          {!areFirstSymptomsFieldsDisabled && (
            <Text as='span' color='red.500'>
              *
            </Text>
          )}
        </FormLabel>
        <Box
          opacity={areFirstSymptomsFieldsDisabled ? 0.4 : 1}
          pointerEvents={areFirstSymptomsFieldsDisabled ? 'none' : 'auto'}
        >
          <BasicDateStringPicker
            startYear='1930'
            endYear={new Date().getFullYear().toString()}
            dateString={profile.firstSymptomsDate || ''}
            setDateString={(value: string) =>
              onUpdate({ firstSymptomsDate: value })
            }
            isDisabled={areFirstSymptomsFieldsDisabled || isFirstSymptomsDateLocked}
          />
        </Box>
      </FormControl>

      <FormControl>
        <FormLabel>
          Date of Diagnosis{' '}
          {extraInfoRequired && (
            <Text as='span' color='red.500'>
              *
            </Text>
          )}
        </FormLabel>
        <Box
          opacity={areDateFieldsDisabled ? 0.4 : 1}
          pointerEvents={areDateFieldsDisabled ? 'none' : 'auto'}
        >
          <BasicDateStringPicker
            startYear='1930'
            endYear={new Date().getFullYear().toString()}
            dateString={profile.diagnosisDate || ''}
            setDateString={(value: string) =>
              onUpdate({ diagnosisDate: value })
            }
            isDisabled={areDateFieldsDisabled || isDiagnosisDateLocked}
          />
        </Box>
      </FormControl>
    </>
  )
}

export default MedicalDatesSection
